import { cn } from "../../../assets/Utils/generic";

const backgroundVariantClasses = {
  dark:
    "bg-[#091112] [background-image:radial-gradient(circle,rgba(255,255,255,0.1)_1px,transparent_1px)]",
  muted:
    "bg-[#151D1E] [background-image:radial-gradient(circle,rgba(255,255,255,0.1)_1px,transparent_1px)]",
  light:
    "bg-white [background-image:radial-gradient(circle,rgba(9,17,18,0.1)_1px,transparent_1px)]",
} as const;

export type StaticPageBackgroundVariant = keyof typeof backgroundVariantClasses;

type StaticPageBackgroundProps = {
  variant: StaticPageBackgroundVariant;
};

export default function StaticPageBackground({
  variant,
}: StaticPageBackgroundProps) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "pointer-events-none absolute inset-0 [background-position:center] [background-size:28px_28px]",
        backgroundVariantClasses[variant],
      )}
    />
  );
}
